"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LAUNCH_DARKLY_CLIENT_SIDE_IDS = exports.COOKIE_FOR_MOBILE_NAME = exports.COOKIE_FOR_SESSION_NAME = exports.IDENTIFIED_USER_SESSION_NAME = exports.DE_LOCALES = exports.GB_LOCALES = exports.LOCAL_ENVS = exports.EXPONEA = exports.EXPONEA_OLD = exports.SNOWPLOW = void 0;
exports.SNOWPLOW = {
  SCHEMA: 'iglu:com.raisin/event_schema/jsonschema/1-0-2',
  TEST_ENDPOINT: 'com-raisin-prod1.mini.snplow.net',
  PROD_ENDPOINT: 'collector.raisin.com',
  TRACKER_ID: 'production',
  APP_IDS: {
    'www.weltsparen.de': 'prod',
    'www.weltsparen.at': 'prod_at',
    'www.raisin.com': 'prod_com',
    'www.raisin.co.uk': 'prod_uk',
    'www.raisin.ie': 'prod_ie',
    'www.raisin.es': 'prod_es',
    'www.raisin.fr': 'prod_fr',
    'www.raisin.nl': 'prod_nl',
    'www.raisin.bank': 'prod_bank',
    'cap.weltsparen.de': 'cap_deu',
    'cap.raisin.co.uk': 'cap_gbr'
  }
};
exports.EXPONEA_OLD = {
  PROD_TOKEN: {
    DE_AT: '5ad5bb04-cff9-11ea-8069-62850c207816',
    EU_GB: '3d293c22-f36a-11ea-922b-eafa027747e1'
  },
  TEST_TOKEN: {
    DE_AT: 'b5ccc144-cb60-11ea-ba6c-9e994002a52c',
    EU_GB: '65e07b30-f36a-11ea-9df7-4e6a9bf87271'
  }
};
exports.EXPONEA = {
  PROD_TOKEN: {
    EU: '5ad5bb04-cff9-11ea-8069-62850c207816',
    GB: '3d293c22-f36a-11ea-922b-eafa027747e1'
  },
  TEST_TOKEN: {
    EU: 'b5ccc144-cb60-11ea-ba6c-9e994002a52c',
    GB: '65e07b30-f36a-11ea-9df7-4e6a9bf87271'
  }
};
exports.LOCAL_ENVS = [/^localhost/, /^core\.dev/, /raisin-dev/, /^bk-/, /bk\./, /staging-/, /amplifyapp/, /app.dev-raisin.com/];
exports.GB_LOCALES = ['en_GB', 'en-GB'];
exports.DE_LOCALES = ['de', 'de_DE', 'de-DE', 'at', 'de_AT', 'de-AT'];
exports.IDENTIFIED_USER_SESSION_NAME = 'user_is_identified';
exports.COOKIE_FOR_SESSION_NAME = 'obs-session';
exports.COOKIE_FOR_MOBILE_NAME = 'mobile';
exports.LAUNCH_DARKLY_CLIENT_SIDE_IDS = {
  local: '61a9f77ca7a8d31143a37089',
  development: '61a9f77ca7a8d31143a37089',
  staging: '61a9f4a34e7888116e020694',
  onboarding: '61a9f4afc6a5f10dd1217229',
  production: '61a9f4530be7e9119fa0857e'
};